import { TitleAndValue } from '../../../../../../components/UI-Elements/TitlesAndTexts/TitleAndValueList';
import { formatToPriceInDollars } from '../../../../../../utils/FormatValue';
import React from 'react';

interface IBackToBackFutureOrderSummeryDataSectionProps {
  clientName?: string;
  orderId: string;
  productName: string;
  quantity: number;
  pricePerUnit: number;
}
export const BackToBackFutureOrderSummeryDataSection: React.FC<IBackToBackFutureOrderSummeryDataSectionProps> = ({
  orderId,
  clientName,
  pricePerUnit,
  productName,
  quantity,
}) => {
  return (
    <>
      <div>
        <h6 className="text-red text-lg">Order details</h6>
        <div className="flex space-x-14">
          <TitleAndValue
            titleValueData={[
              { title: 'Order ID', valueAsString: orderId },
              ...(clientName ? [{ title: 'Client name', valueAsString: clientName }] : []),
              { title: 'Product', valueAsString: productName },
              { title: 'Product quantity', valueAsString: quantity.toLocaleString() },
              {
                title: 'Price per product unit',
                valueAsString: formatToPriceInDollars(pricePerUnit || 0),
              },
              {
                title: 'Total expected price',
                valueAsString: pricePerUnit ? formatToPriceInDollars(pricePerUnit * quantity) : 'undefined',
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};
